import React, { useContext } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import ContainerComponent from "../Container/ContainerComponent";
import BoxComponent from "../Box/BoxComponent";
import ImageLogoComponent from "../Image/ImageLogoComponent";
import ButtonComponent from "../Button/ButtonComponent";

import LogoIcon from "../../assets/images/logo_genioai.png";

import { ReactComponent as HomeIcon } from "../../assets/icons/home.svg";
import { ReactComponent as PromocaoIcon } from "../../assets/icons/PromocaoIcon.svg";
import { ReactComponent as PedidosIcon } from "../../assets/icons/pedidos.svg";
import { ReactComponent as PerfilIcon } from "../../assets/icons/perfil.svg";
import HeaderButtonComponent from "./HeaderButtonComponent";
import HeaderProfileDropdownComponent from "./HeaderProfileDropdownComponent";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../provider/auth/AuthContext";

const HeaderComponent = () => {
    const theme = useTheme()
    const { usuario, cliente } = useContext(AuthContext);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const navigate = useNavigate();

    const handleOptionClicked = (option: string) => {
        navigate(option);
    }

    const isPaginaAtual = (path: string) => {
        return window.location.pathname.endsWith(path);
    }

    return <ContainerComponent
        component="div"
        sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%"
        }}
    >
        {/* {!isMobile && (
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    flex: 3
                }}
            >
                <ButtonComponent id="logo">
                    <ImageLogoComponent
                        sx={{
                            margin: 1.85,
                            width: 45,
                            height: 45,
                            borderRadius: 2
                        }}
                        src={LogoIcon}
                        alt="logo"
                    />
                </ButtonComponent>
            </BoxComponent>
        )} */}
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                flex: isMobile ? 2 : 1,
                // width: "100%",
                justifyContent: "space-between",
                width: "100%"
            }}
        >
            <HeaderButtonComponent
                label="Início"
                value="catalogo"
                icon={<HomeIcon />}
                active={isPaginaAtual("catalogo")}
                onClickOption={(option: string) => handleOptionClicked(option)}
            />
            <HeaderButtonComponent
                label="Promoções"
                value="catalogo/promocoes"
                icon={<PromocaoIcon />}
                active={isPaginaAtual("promocoes")}
                onClickOption={(option: string) => handleOptionClicked(option)}
                disabled={true}
            />
            <HeaderButtonComponent
                label="Pedidos"
                value="catalogo/pedidos/usuario"
                icon={<PedidosIcon />}
                active={isPaginaAtual("pedidos/usuario")}
                disabled={cliente == null}
                onClickOption={(option: string) => handleOptionClicked(option)}
            />
            {/* <HeaderProfileDropdownComponent /> */}
            <HeaderButtonComponent
                label="Perfil"
                value="catalogo/login"
                icon={<PerfilIcon />}
                active={isPaginaAtual("login")}
                onClickOption={(option: string) => handleOptionClicked(option)}
            />
        </BoxComponent>
    </ContainerComponent>
}

export default HeaderComponent;